export const REGION_REPLICATION_MAP: Record<string, Array<string>> = {
  // editing for Hong Kong replicates to Taiwan
  HK: ['TW'],
  // editing for Singapore replicates to multiple Asian regions
  SG: ['HK', 'MY', 'TW', 'CN', 'IN', 'ID', 'JP', 'KR', 'PH', 'TH', 'VN', 'MO'],
  // editing for USA replicates to Canada
  US: ['CA'],
  // editing for South Africa replicates to Israel, Saudi Arabia, United Arab Emirates
  ZA: ['IL', 'SA', 'AE'],
  // editing for United Kingdom replicates to European regions
  GB: ['FR', 'DE', 'IE', 'IT', 'NL', 'RU', 'ES'],
};
